import SessionService from "../../../../../../services/session/SessionService";
import { Weather } from "../weather/Weather";
import { Clock } from "../clock/Clock";
import { NavigateItem, NavigateItems, NavigatorCenter, NavigatorLeft, NavigatorRight, NavigatorWrapper, ScreenTitle, ScreenTitleCn, NavigateItemSeparator, TitleBorder, BorderLeftCircle, BorderLeftBlock, BorderLine} from "./Navigator.styled";

interface NavigatorProps {
    selected?: string
}

let Navigator: React.FC<NavigatorProps> = (props)=> {
  //  let tenantNo = SessionService.getInstance().getCurrentUserProfile().tenantNo;
    let title = {
        cn: "牵引车智能互联系统",
       
    };
    // if (tenantNo == 'RTZB') {
    //     title = {
    //         cn: "电动轮智能监测互联系统",
    //         en: "Electric Wheel Intelligent Monitoring Link System"
    //     };
    // };

    return (
        <NavigatorWrapper>
            <NavigatorLeft>
                 <ScreenTitle>
                    <ScreenTitleCn>{title.cn}</ScreenTitleCn>
                </ScreenTitle>
                
            </NavigatorLeft>

            <NavigatorCenter>
               <NavigateItems>
                    <NavigateItem href={SessionService.getInstance().getCurrentUserProfile().admin ? "/#/" : '#'}>管理控制台</NavigateItem>
                    <NavigateItemSeparator />
                    <NavigateItem href="/#/big-screen/overview" className={props.selected=='OVERVIEW' ? "selected" : "" }>系统总览</NavigateItem>
                    <NavigateItemSeparator />
                    <NavigateItem className={props.selected=='DEVICE_DETAILS' ? "selected" : "" }>设备详情</NavigateItem>
                </NavigateItems>
            </NavigatorCenter>

            <NavigatorRight>
                <Weather />
                <Clock />
            </NavigatorRight>

            <TitleBorder>
                <BorderLeftCircle />
                <BorderLeftBlock />
                <BorderLine />
                
                
            </TitleBorder>
        </NavigatorWrapper>
    )
};

export default Navigator;
